import { useEffect } from 'react';
import { useI18n } from '../i18n';

/**
 * Custom hook to manage document title
 * @param {string} titleKeyOrText - Translation key or fallback page title
 * @param {boolean} includeAppName - Whether to append "- Zync Desk" to the title (default: true)
 */
const useTitle = (titleKeyOrText, includeAppName = true) => {
  const { t } = useI18n();

  useEffect(() => {
    const prevTitle = document.title;

    if (titleKeyOrText) {
      const resolvedTitle = t(titleKeyOrText, {}, titleKeyOrText);
      const appName = t('common.app_name', {}, 'Zync Desk');
      document.title = includeAppName
        ? `${resolvedTitle} - ${appName}`
        : resolvedTitle;
    }

    // Cleanup: restore previous title when component unmounts
    return () => {
      document.title = prevTitle;
    };
  }, [titleKeyOrText, includeAppName, t]);
};

export default useTitle;
